import React, { useState } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const inputStyle = {
  width: '100%',
  padding: '10px',
  margin: '8px 0 16px',
  borderRadius: '6px',
  border: '1px solid #ccc',
  fontSize: '1rem',
  fontFamily: "'Nunito', sans-serif"
};

const buttonStyle = {
  width: '100%',
  padding: '12px',
  borderRadius: '6px',
  backgroundColor: '#4dabf7',
  color: '#fff',
  fontWeight: 'bold',
  fontSize: '1rem',
  border: 'none',
  cursor: 'pointer',
  transition: 'background 0.2s'
};

function RecommendForm() {
  const [kofiUrl, setKofiUrl] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE}/submissions`, {
        type: 'recommendation',
        kofi_url: kofiUrl
      });
      setSuccess(true);
      setKofiUrl('');
    } catch (err) {
      alert('Error submitting recommendation: ' + err.message);
    }
  };

  return (
    <div style={{
      maxWidth: '500px',
      margin: '40px auto',
      padding: '20px',
      borderRadius: '10px',
      background: '#f9f9f9',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)',
      fontFamily: "'Nunito', sans-serif"
    }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Recommend a Ko-fi Creator</h2>

      <p style={{ fontSize: '0.95rem', color: '#444', marginBottom: '20px', textAlign: 'center' }}>
        Know a Ko-fi creator who deserves more love? 💛  
        Recommend their page and we’ll feature it in our public directory as a fan-picked gem.
      </p>


      {success && <p style={{ color: 'green', textAlign: 'center' }}>Thanks for your recommendation!</p>}

      <form onSubmit={handleSubmit}>
        <label>Ko-fi Link</label>
        <input
          type="url"
          placeholder="https://ko-fi.com/creatorname"
          value={kofiUrl}
          onChange={(e) => setKofiUrl(e.target.value)}
          required
          style={inputStyle}
        />

        <button type="submit" style={buttonStyle}>Submit</button>
      </form>
    </div>
  );
}

export default RecommendForm;

